import { StyleBreadcrumb, StyleBreadcrumbWrapper } from './style'

interface IBreadcrumb {
  title: string
  customStyle?: any
}
const Breadcrumb = ({ title, ...restProps }: IBreadcrumb) => {
  return (
    <StyleBreadcrumbWrapper {...restProps}>
      <StyleBreadcrumb>{title}</StyleBreadcrumb>
    </StyleBreadcrumbWrapper>
  )
}

export default Breadcrumb
